/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSubscriptionUsage200ResponseSmsSent
 */
export interface GetSubscriptionUsage200ResponseSmsSent {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseSmsSent
     */
    price: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetSubscriptionUsage200ResponseSmsSent
     */
    perDay: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseSmsSent
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseSmsSent
     */
    lastMonthCount: number;
}

/**
 * Check if a given object implements the GetSubscriptionUsage200ResponseSmsSent interface.
 */
export function instanceOfGetSubscriptionUsage200ResponseSmsSent(value: object): value is GetSubscriptionUsage200ResponseSmsSent {
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('perDay' in value) || value['perDay'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('lastMonthCount' in value) || value['lastMonthCount'] === undefined) return false;
    return true;
}

export function GetSubscriptionUsage200ResponseSmsSentFromJSON(json: any): GetSubscriptionUsage200ResponseSmsSent {
    return GetSubscriptionUsage200ResponseSmsSentFromJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseSmsSentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionUsage200ResponseSmsSent {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'],
        'perDay': json['perDay'],
        'count': json['count'],
        'lastMonthCount': json['lastMonthCount'],
    };
}

export function GetSubscriptionUsage200ResponseSmsSentToJSON(json: any): GetSubscriptionUsage200ResponseSmsSent {
    return GetSubscriptionUsage200ResponseSmsSentToJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseSmsSentToJSONTyped(value?: GetSubscriptionUsage200ResponseSmsSent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'price': value['price'],
        'perDay': value['perDay'],
        'count': value['count'],
        'lastMonthCount': value['lastMonthCount'],
    };
}

